export default __webpack_public_path__ + "b7b62c86aa26355e389020d45b1d16be.svg";